import { Grid } from '@mui/material';
import StudentsSubmissionsChart from './StudentsSubmissionsChart';
import TransactionsChart from './TransactionsChart';
import StudentSubmissionsDonut from './StudentSubmissionsDonut';
import TransactionsDonut from './TransactionsDonut';
import TasksChart from './TasksChart';
import TasksDonut from './TasksDonut';

function Analytics() {
  return (
    <Grid container height="100%" flexDirection="row" spacing={1}>
      <Grid container item height="50%" gap={1} md={12}>
        <TransactionsChart />
        <TransactionsDonut />
      </Grid>
      <Grid container item height="50%" gap={1} md={12}>
        <StudentsSubmissionsChart />
        <StudentSubmissionsDonut />
      </Grid>
      <Grid container item height="50%" gap={1} md={12}>
        <TasksChart />
        <TasksDonut />
      </Grid>
    </Grid>
  );
}

export default Analytics;
